import React from 'react';
import classNames from 'classnames';
import { bool, object } from 'prop-types';
import { useDispatch } from 'redux-react-hook';
import { Link } from '@reach/router';
import { linkTo } from 'utils/links';
import { ellipsis } from 'utils/text';

// redux
import { play } from 'store/modules/player/actions';

// Components
import Button from 'components/Button';
import Image from 'components/Image';
import Play from 'components/Icon/Play';

import './Thumbnail.css';

const singles = ['single', 'hymnal'];

export default function Thumbnail({ song, list, vertical, style }) {
  const dispatch = useDispatch();
  const title = ellipsis(song.title, 30);
  const url = song.album && singles.includes(song.album.type)
    ? linkTo('/songs/:slug', song)
    : linkTo(`${linkTo('/albums/:slug', song.album)}/:slug`, song);

  return (
    <div className={classNames('flex flex-col', { 'md:flex-row': !vertical })} style={style}>
      <div className={classNames('Song__Thumbnail relative rounded mx-2 md:mx-0', {
        'md:w-1/4 xl:w-1/6': !vertical
      })}>
        {song.sound &&
          <div className="Song__Thumbnail__actions bg-thumbnail flex flex-col items-center justify-center absolute inset-0 hover:rounded">
            <Button onClick={() => dispatch(play(song, list))} type="plain" className="text-secondary hover:text-default">
              <Play width={50} height={50} className="fill-current" />
            </Button>
          </div>
        }
        <Image src={song.album && song.album.image} className="w-full h-auto rounded block bg-cover bg-list-active" background />
      </div>
      <div
        className={
          classNames('flex flex-col flex-1 mx-2 justify-center overflow-hidden md:mx-0', {
            'md:px-3 xl:px4': !vertical,
          })}
      >
        <h4
          className={classNames('leading-tight mt-1', {
            'md:mt-0': !vertical,
          })}
          title={song.title}
        >
          <Link
            to={url}
            className="block font-sans text-base font-medium text-default paragraph hover:underline xl:text-lg xl:font-medium"
          >
            {title}
          </Link>
        </h4>
        <p className="text-sm text-secondary">
          <Link
            to={linkTo('/members/profiles/:slug', song.author)}
            className="text-secondary hover:underline"
          >
            {song.author && song.author.name}
          </Link> {song.duration && <span className="hidden md:inline">&bull; {song.duration && song.duration.substring(3)}</span>}
        </p>
      </div>
    </div>
  );
}

Thumbnail.proptypes = {
  song: object,
  vertical: bool,
};

Thumbnail.defaultProps = {
  vertical: false
};
